import { cva, type VariantProps } from '@repo/ui/lib/cva';
import { cn } from '@repo/ui/lib/utils';
import { Slot } from 'radix-ui';
import type * as React from 'react';

const buttonVariants = cva(
  "group/button inline-flex shrink-0 select-none items-center justify-center whitespace-nowrap rounded-sm border border-transparent bg-clip-padding outline-none transition-all focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: 'bg-[#1B3098] text-background [a]:hover:bg-background/80',
        secondary: 'bg-[#7B6184] text-background [a]:hover:bg-background/80',
        ghost: 'bg-[#C4B6C980] text-foreground [a]:hover:bg-foreground/80',
      },
      size: {
        default: 'h-14 w-48 gap-1.5 px-2.5 font-semibold text-xl',
        sm: 'h-10 w-32 gap-1.5 px-2.5 font-semibold text-xs',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

function LandingButton({
  className,
  variant = 'default',
  size = 'default',
  asChild = false,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  } & { loading?: boolean }) {
  const Comp = asChild ? Slot.Root : 'button';
  const isDisabled = props.disabled;

  if (asChild) {
    return (
      <Slot.Slot
        className={cn('cursor-pointer', buttonVariants({ variant, size, className }))}
        data-size={size}
        data-slot="button"
        data-variant={variant}
        disabled={isDisabled}
        {...props}
      />
    );
  }
  return (
    <button
      className={cn('cursor-pointer', buttonVariants({ variant, size, className }))}
      data-size={size}
      data-slot="button"
      data-variant={variant}
      disabled={isDisabled}
      {...props}
    >
      {props.children}
    </button>
  );
}

export { LandingButton };
